<template lang="pug">
  button(@click="startChat")
    slot
</template>

<script>
  import sierraChatWidgetMixin from "@mixins/chatWidgetMixin/sierraChatWidgetMixin";

  export default {
    name: "SierraStartChatBtn",
    mixins: [sierraChatWidgetMixin],

    props: {
      initialMessage: {
        type: String,
        default: "Hello, I need help!"
      },
      emptyChat: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      startChat() {
        this.trackMREvent("Sierra Chat - Start Chat Button Clicked", {
          initialMessage: this.emptyChat ? "No initial Message" : this.initialMessage,
        });
        if (this.emptyChat) {
          this.mix_openSierraEmptyChat();
          return;
        }
        this.mix_openSierraChatWithInitialMessage(this.initialMessage);
      }
    }
  };
</script>

<style scoped lang="stylus">
</style>
